// Visitor context + identity side panel.
import type { ReactNode } from 'react';
import type { LiveChatConversation } from '../mockData.js';

export function VisitorContext({ convo }: { convo: LiveChatConversation }): ReactNode {
  return (
    <aside className="stack">
      <section className="card">
        <div className="head">
          <h2>Visitor context</h2>
        </div>
        <div className="body">
          <dl className="context">
            <div>
              <dt>Viewing</dt>
              <dd id="viewing">{convo.viewing}</dd>
            </div>
            <div>
              <dt>Arrived from</dt>
              <dd id="arrival">{convo.arrival}</dd>
            </div>
            <div>
              <dt>On site</dt>
              <dd>{convo.onSite}</dd>
            </div>
            <div>
              <dt>Identity</dt>
              <dd id="context-identity">
                {convo.identity === 'anonymous' ? 'Anonymous' : 'Verified'}
              </dd>
            </div>
          </dl>
        </div>
      </section>
      <section className="card">
        <div className="head">
          <h2>Customer identity</h2>
        </div>
        <div className="body">
          <p>Verified website identity connects this chat to the customer automatically.</p>
          <p className="hint">
            Guest visitors can keep chatting. Customer details appear after verification.
          </p>
        </div>
      </section>
      <section
        className="card body"
        style={{ paddingTop: 12, paddingBottom: 17 }}
        id="customer-panel"
      >
        {convo.verifiedCustomerId ? (
          <p>
            Linked to <strong>{convo.label}</strong> ({convo.verifiedCustomerId}).
          </p>
        ) : (
          <p>No verified customer yet.</p>
        )}
      </section>
    </aside>
  );
}
